import { Button, Card, CardContent, Chip, Stack, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LinkIcon from '@mui/icons-material/Link';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { cardStyles, metaStripStyles } from './eventDetailsStyles';

const formatEventType = (eventType) => {
  const normalized = String(eventType || '').trim();
  if (!normalized) return 'event';
  return normalized.replace(/[_-]/g, ' ').toLowerCase();
};

const MoreInformationCard = ({ documents = [], eventType = '' }) => {
  if (!documents.length) return null;

  const readableEventType = formatEventType(eventType);
  const introText = `More details about this ${readableEventType} are available below.`;

  return (
    <Card sx={cardStyles.section}>
      <CardContent>
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
          <InfoOutlinedIcon sx={metaStripStyles.icon} />
          <Typography variant="h6" sx={{ fontWeight: 700 }}>More Information</Typography>
        </Stack>

        <Typography color="text.secondary" sx={{ mb: 2 }}>{introText}</Typography>

        <Stack spacing={1.5}>
          {documents.map((document) => (
            <Stack
              key={document.id || `${document.label}-${document.href}`}
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'flex-start', sm: 'center' }}
              justifyContent="space-between"
              spacing={1}
              sx={{ p: 1.5, border: '1px solid #e5e7eb', borderRadius: 2, bgcolor: '#fcfdfd', '&:hover': { bgcolor: '#f8fafc' } }}
            >
              <Stack direction="row" spacing={1} alignItems="center" sx={{ minWidth: 0 }}>
                {document.isAttachment ? <AttachFileIcon fontSize="small" /> : <LinkIcon fontSize="small" />}
                <Typography sx={{ fontWeight: 600, overflowWrap: 'anywhere' }} title={document.label || 'Supporting document'}>
                  {document.label || 'Supporting document'}
                </Typography>
                <Chip size="small" label={document.isAttachment ? 'Attachment' : 'Link'} />
              </Stack>

              <Button
                component="a"
                href={document.href}
                target={document.open_new_tab ? '_blank' : undefined}
                rel={document.open_new_tab ? 'noreferrer noopener' : undefined}
                size="small"
                variant="outlined"
                endIcon={document.open_new_tab ? <OpenInNewIcon fontSize="small" /> : null}
                aria-label={`${document.isAttachment ? 'Download file' : 'Open link'}: ${document.label || 'Supporting document'}`}
              >
                {document.isAttachment ? 'Download File' : 'Open Link'}
              </Button>
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default MoreInformationCard;
